import { Typography, Box, Button, Grid } from '@mui/material';
import React from 'react';
import cx from 'classnames';
import { ReactComponent as BoltIcon } from 'new/components/icons/fi-rr-bolt.svg';
import { ReactComponent as DatabaseIcon } from 'new/components/icons/fi-rr-database.svg';
import styles from './PipelinesEmptyListGuide.module.scss';

interface Source {
  key: string;
  displayName?: string;
  iconSm?: string;
  industryCategory?: string;
  setupTime?: string;
  description?: string;
}

interface GuideListSourcesProps {
  sources: Source[];
  onSourceSelection: (connectionKey: string | null) => void;
  hasExpressTierLimitedAccess?: boolean;
}

const GuideListSources: React.FC<GuideListSourcesProps> = ({
  sources,
  onSourceSelection,
  hasExpressTierLimitedAccess,
}) => {
  return (
    <div className={styles.sourcesList}>
      <Typography variant="bodyLarge" className={styles.sourcesListTitle}>
        Popular Data Sources
      </Typography>
      <Grid container spacing={2} className={styles.sourcesGrid}>
        {sources.map((source) => (
          <Grid item xs={12} sm={6} md={4} key={source.key}>
            <Box className={cx(styles.topSourceCard, styles.card)}>
              <div className={styles.cardHeader}>
                <div className={styles.sourceIcon}>
                  {source.iconSm && <img src={source.iconSm} alt={source.displayName} />}
                </div>
                <div className={styles.cardTitleSection}>
                  <Typography variant="bodyLarge" className={styles.sourceName}>
                    {source.displayName}
                  </Typography>
                  <div className={styles.categoryRow}>
                    <Typography variant="bodySmall" className={styles.category}>
                      {source.industryCategory}
                    </Typography>
                    {source.setupTime && (
                      <div className={styles.setupTime}>
                        <BoltIcon />
                        <Typography variant="bodySmall">{source.setupTime}</Typography>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <Typography variant="bodyDefault" className={styles.sourceDescription}>
                {source.description}
              </Typography>
              {!hasExpressTierLimitedAccess && (
                <Button
                  variant="outlined"
                  size="small"
                  className={styles.newFlowButton}
                  onClick={() => onSourceSelection(source.key)}
                >
                  New Data Flow
                </Button>
              )}
            </Box>
          </Grid>
        ))}
      </Grid>
      {!hasExpressTierLimitedAccess && (
        <Button
          variant="outlined"
          size="small"
          className={styles.viewAllButton}
          startIcon={<DatabaseIcon />}
          onClick={() => onSourceSelection(null)}
        >
          Browse All 500+ Connectors
        </Button>
      )}
    </div>
  );
};

export default GuideListSources;
